import type { WalkthroughConfig } from "./types";
import { masterOverviewWalkthrough } from "./configs/masterOverview";
import { dashboardWalkthrough } from "./configs/dashboard";
import { membersWalkthrough } from "./configs/members";
import { eventsWalkthrough } from "./configs/events";
import { communicationsWalkthrough } from "./configs/communications";
import { programmingWalkthrough } from "./configs/programming";
import { reportsWalkthrough } from "./configs/reports";
import { websiteWalkthrough } from "./configs/website";
import { signatureEventsWalkthrough } from "./configs/signatureEvents";

export const walkthroughRegistry: WalkthroughConfig[] = [
  masterOverviewWalkthrough,
  dashboardWalkthrough,
  membersWalkthrough,
  eventsWalkthrough,
  signatureEventsWalkthrough,
  programmingWalkthrough,
  communicationsWalkthrough,
  websiteWalkthrough,
  reportsWalkthrough,
];

export function getWalkthroughById(id: string): WalkthroughConfig | undefined {
  return walkthroughRegistry.find((w) => w.id === id);
}

export function getWalkthroughsForRoute(route: string): WalkthroughConfig[] {
  return walkthroughRegistry.filter((w) => w.pageRoute && route.startsWith(w.pageRoute));
}

export function getWalkthroughsByCategory(category: string): WalkthroughConfig[] {
  return walkthroughRegistry.filter((w) => w.category === category);
}
